import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../config/routes';

export default function EquipmentIntroPage() {
  return <Navigate to={{ pathname: ROUTES.root, hash: '#equipment' }} replace />;
}
